import DOMPurify from 'dompurify';

// Tags the RichTextEditor can produce (execCommand output plus the <div>
// blocks browsers insert on Enter). Keep in sync with
// backend/app/core/html_sanitize.py.
const RICH_TEXT_TAGS = ['b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'h3', 'p', 'div', 'br'];

export function sanitizeRichText(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: RICH_TEXT_TAGS, ALLOWED_ATTR: [] });
}
